// extracted by mini-css-extract-plugin
export var alpha = "_8l-4";
export var alphaInputContainer = "_8l-f";
export var badge = "_8l-b";
export var brandKitGrid = "_8l-h";
export var brandKitItem = "_8l-i";
export var brandKitSwatch = "_8l-j";
export var controls = "_8l-5";
export var formatDropdown = "_8l-d";
export var formatSelector = "_8l-c";
export var hex = "_8l-6";
export var hexInput = "_8l-e";
export var hue = "_8l-3";
export var hueAndAlphaPointer = "_8l-a";
export var percentageLabel = "_8l-g";
export var picker = "_8l-0";
export var rgba = "_8l-8";
export var rgbaSection = "_8l-7";
export var saturation = "_8l-1";
export var saturationPointer = "_8l-9";
export var sliders = "_8l-2";